import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-[100] px-6 py-5 flex items-center justify-between bg-bg-primary/85 backdrop-blur-[20px] border-b border-cyan/10" data-id="element-204">
      <a href="#" className="flex items-center gap-3 decoration-transparent" data-id="element-205">
        <img src="https://cdn.magicpatterns.com/uploads/ruDyDBcXCQm2ZT5vfYephk/LOGO_PROFUMIND.png" alt="Profumind Logo" className="w-[38px] h-[38px] rounded-full object-cover" data-id="element-206" />
        <span className="text-[15px] font-heading font-bold uppercase text-white tracking-[0.15em]" data-id="element-207">
          Profumind
        </span>
      </a>
      <a href="#solucion" className="bg-transparent border border-cyan text-cyan px-3 py-1.5 rounded-sm text-[10px] md:text-[11px] font-heading font-semibold uppercase tracking-[0.08em] cursor-pointer decoration-transparent whitespace-nowrap transition-all duration-250 ease-in hover:bg-cyan hover:text-black hover:shadow-[0_0_20px_rgba(0,229,255,0.4)]" data-id="element-208">
        Get More Info →
      </a>
    </nav>;
}